import { AnnouncementModalLayout, Text } from '@wix/design-system';
import React, { useEffect } from 'react';
import ConnectDomainIllustration from '../../assets/images/connectDomain.svg';
import { connectDomainLink } from '../../consts';
import { reportModalCtaClick, reportModalShown } from '../../bi/bi';
import { Modals } from '../../types';
import { useLibraryTranslations } from '../../context/TranslationsContext';
import { useInstallerContext } from '../../context/InstallerContext';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
export const ConnectDomain = () => {
  const {
    t
  } = useLibraryTranslations();
  const {
    modals
  } = useModalsAndWindow();
  const {
    tenantId,
    preInstallationData: {
      app
    }
  } = useInstallerContext();
  useEffect(() => {
    reportModalShown(Modals.connectDomain);
  }, []);
  const connectText = t('connect-a-domain.description');
  return /*#__PURE__*/React.createElement(AnnouncementModalLayout, {
    dataHook: "connect-domain-modal-layout",
    illustration: /*#__PURE__*/React.createElement(ConnectDomainIllustration, null),
    title: t('connect-a-domain.title', {
      appName: app == null ? void 0 : app.name
    }),
    primaryButtonText: t('connect-a-domain.upgrade-button'),
    primaryButtonOnClick: () => {
      reportModalCtaClick({
        ctaName: 'connect button',
        modalType: Modals.connectDomain
      });
      const connectDomainUrl = connectDomainLink(tenantId);
      window.open(connectDomainUrl);
      modals.connectDomain.close({
        answer: 'CONNECT_DOMAIN'
      });
    },
    onCloseButtonClick: () => {
      reportModalCtaClick({
        ctaName: 'close',
        modalType: Modals.connectDomain
      });
      modals.connectDomain.close({
        answer: 'CONNECT_DOMAIN'
      });
    }
  }, /*#__PURE__*/React.createElement(Text, null, connectText));
};
//# sourceMappingURL=ConnectDomain.js.map